import React from 'react';

const EditAssetModal = ({
  editingAsset,
  setEditingAsset,
  editAssetForm,
  setEditAssetForm,
  assignableUsers = [],
  handleEditAsset,
  selectedFile,
  setSelectedFile,
  isUploading,
  isLoading,
}) => {
  if (!editingAsset) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs flex items-center justify-center z-50 p-4">
      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden text-slate-800 animate-fadeIn">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <h3 className="text-base font-bold">Edit Asset</h3>
          <button
            onClick={() => setEditingAsset(null)}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleEditAsset} className="p-5 space-y-4 text-xs max-h-[80vh] overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Asset Name</label>
              <input
                type="text"
                required
                className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
                value={editAssetForm.name}
                onChange={(e) => setEditAssetForm({ ...editAssetForm, name: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Asset Type</label>
              <select
                required
                className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
                value={editAssetForm.asset_type}
                onChange={(e) => setEditAssetForm({ ...editAssetForm, asset_type: e.target.value })}
              >
                <option value="">Select Type</option>
                <option value="laptop">Laptop</option>
                <option value="desktop">Desktop</option>
                <option value="mobile">Mobile</option>
                <option value="monitor">Monitor</option>
                <option value="printer">Printer</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Description</label>
            <textarea
              required
              rows={3}
              className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
              value={editAssetForm.description}
              onChange={(e) => setEditAssetForm({ ...editAssetForm, description: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Value (₹)</label>
              <input
                type="number"
                required
                min="0"
                step="0.01"
                className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
                value={editAssetForm.value}
                onChange={(e) => setEditAssetForm({ ...editAssetForm, value: parseFloat(e.target.value) || 0 })}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Serial Number</label>
              <input
                type="text"
                className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none font-mono"
                value={editAssetForm.serial_number}
                onChange={(e) => setEditAssetForm({ ...editAssetForm, serial_number: e.target.value })}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Assign to User</label>
            <select
              className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
              value={editAssetForm.assigned_to || ''}
              onChange={(e) => setEditAssetForm({ ...editAssetForm, assigned_to: e.target.value || '' })}
            >
              <option value="">Unassigned</option>
              {assignableUsers.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.username}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Update Photo (Optional)</label>
            <div className="flex items-center gap-2">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                className="flex-1 text-xs border border-slate-200 rounded-xl p-2 bg-slate-50 focus:bg-white"
              />
              {selectedFile && (
                <button
                  type="button"
                  onClick={() => setSelectedFile(null)}
                  className="px-3 py-2 text-xs font-bold text-red-600 hover:bg-red-50 rounded-xl"
                >
                  Remove
                </button>
              )}
            </div>
            {isUploading && <p className="text-[11px] text-blue-600 mt-1 font-semibold">Uploading photo...</p>}
          </div>

          <div className="flex justify-end gap-2.5 pt-3 border-t border-slate-100">
            <button
              type="button"
              onClick={() => setEditingAsset(null)}
              className="px-4 py-2 text-xs font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-xl shadow-xs disabled:opacity-50 transition-all"
            >
              {isLoading ? 'Updating...' : 'Update Asset'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAssetModal;
